export interface ISpotlightItem {
  level: string;
  avatar: string;
  name: string;
}

export enum SpotlightFilter {
  Customers = "Customers / Partners",
  Oracle = "Oracle Employees",
}
